import React from 'react';

import http from 'api/http';
import { boatAPI, componentAPI, systemAPI } from 'api/requests';

import Systems from './Systems';
import AdditionalSection from './AdditionalSection';
import SteeringSystemSection from './SteeringSystemSection';
import CombinationPicker from './CombinationPicker';
import CombinationSection from './CombinationSection';
import NotificationManager from 'dom-managers/notification';
import ApplicationActions from 'Components/ApplicationActions';
import Modal from 'Components/Modal';
import Button, { buttonColor, buttonType } from 'Components/Button';

const INFO = {
  1: ['Please select one Blower.'],
  2: [
    'Configuration 1 (under 12 m): Please select one or two Side Light or Combination Side Light, one Combination Masthead/Anchor Light or one All-around Light, and one optional Tricolor Light.',
    'Configuration 2 (12 m and over): Please select one or two Side Light or Combination Side Light, and one Masthead Light or Combination Masthead/Anchor Light, and one Stern Light, and one optional Tricolor Light.',
  ],
  3: ['Please select at least one Bilge Pump.'],
  4: ['Please select one Horn (5 to 12m, 12 to 20m, or more than 20m).'],
  5: [
    'Please select at least one Steering Wheel and at least one Steering Helm Assembly (Electrical, Hydraulic or Mechanical).',
  ],
  6: ['Please select at least one Tank, at least one Fill Hose, at least one Feed Hose, and at least one Vent Hose.'],
};

export default class AddComponents extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      currentSystem: {},
      allComponents: {},
      allManufacturers: {},
      savedComponents: [],
      selectedCombination: {},
      invalidList: {},
      validList: {},
      invalidComponents: {},
      boatSystems: [...(props.boat.boatSystems || [])],
      dualSteering: props.boat.dualSteering !== undefined ? props.boat.dualSteering : undefined,
      selectedTypes: {},
      selectedManufacturersFilters: {},
    };

    this.loadedTypes = {};
    this.additionalSectionName = '';
    this.allSystemsList = [];
    this.systemStructures = {};
    this.AmountOfNotValidatedSystems = 0;
  }

  componentDidMount() {
    const { boatSystems } = this.state;

    let dataRequests = [http.get(systemAPI.getAvailableBoatSystemsList), http.get(componentAPI.types)];

    Promise.all(dataRequests).then(result => {
      this.allSystemsList = result[0].data;
      this.allTypesList = result[1].data;
      this.setState({ invalidList: {}, validList: {} }, () => {
        this.AmountOfNotValidatedSystems = boatSystems.length;
        Promise.all(
          boatSystems.map((systemEntry, index) => {
            this.setSystemsNames(boatSystems[index]);
            return this.validateNotSelectedSystem(index);
          })
        ).then(() => {
          if (boatSystems.length) this.handleSystemChoose(0, true);
        });
      });
    });
  }

  shouldComponentUpdate(nextProps) {
    const { boatSystems } = this.state;

    if (this.props.boat.boatSystems) {
      if (boatSystems.length < nextProps.boat.boatSystems.length) {
        this.setState(
          {
            boatSystems: nextProps.boat.boatSystems,
            invalidList: {},
            validList: {},
            dualSteering: nextProps.boat.boatSpecifications.dualSteering,
          },
          () => {
            this.AmountOfNotValidatedSystems = boatSystems.length;
            Promise.all(
              boatSystems.map((systemEntry, index) => {
                this.setSystemsNames(boatSystems[index]);
                return this.validateNotSelectedSystem(index);
              })
            ).then(() => {
              if (boatSystems.length) this.handleSystemChoose(0, true);
            });
          }
        );
      }
    }

    return true;
  }

  handleSystemAdd = system => {
    const { markStepAsRedacted } = this.props;
    const { boatSystems, selectedTypes } = this.state;

    markStepAsRedacted();
    const componentSystemId = system.id;

    boatSystems.push({
      componentSystemId,
      name: '',
      ruleValueRequests: [],
      optionValueRequests: [],
    });

    selectedTypes[boatSystems.length - 1] = {};

    this.setState(
      {
        boatSystems,
        selectedTypes,
      },
      () => {
        this.setSystemsNames(system);
        this.handleSystemChoose(this.state.boatSystems.length - 1, boatSystems.length === 1);
      }
    );
  };

  handleSystemChoose = (key, doNotSavePreviousSystem) => {
    const { boatSystems, currentSystem } = this.state;
    const { updateBoatDetails } = this.props;
    if (key !== currentSystem.index) {
      const chooseSystem = () => {
        const fullName = this.allSystemsList.find(sys => sys.id === boatSystems[key].componentSystemId).name;
        let systemName = fullName.split('(')[1] && fullName.split('(')[1].split(')')[0];
        this.additionalSectionName = systemName || boatSystems[key].name;

        let newSystem = {};
        let selectedCombination = {};
        let combinations = [];

        const createNewSystemDataEntry = data => {
          newSystem = data;
          newSystem.index = key;
          combinations = newSystem.combinations;
          selectedCombination = this.getChosenCombination(combinations, boatSystems[key]);
          this.setState(
            {
              currentSystem: newSystem,
              selectedCombination: selectedCombination,
              selectedManufacturersFilters: {},
            },
            () => {
              const { boatSystems } = this.state;
              updateBoatDetails({ boatSystems });
            }
          );
        };

        if (this.systemStructures[boatSystems[key].componentSystemId]) {
          createNewSystemDataEntry(this.systemStructures[boatSystems[key].componentSystemId]);
        } else {
          http.get(systemAPI.getBoatSystemStructure(boatSystems[key].componentSystemId)).then(({ data }) => {
            createNewSystemDataEntry(data);
          });
        }
      };

      if (!doNotSavePreviousSystem) {
        this.saveSystem(currentSystem.index).finally(() => {
          chooseSystem();
        });
      } else {
        chooseSystem();
      }
    }
  };

  getChosenCombination = (combinations, system) => {
    let selectedCombination = combinations[0];
    let maxMatchedRules = 0;

    if (combinations.length > 1) {
      combinations.forEach(combination => {
        let matchedRules = 0;
        combination.requiredRules.forEach(combinationRule => {
          system.ruleValueRequests.forEach(systemRule => {
            if (systemRule.ruleId === combinationRule.id)
              matchedRules += Object.keys(systemRule.componentIdWithQuantityMap).length;
          });
        });
        if (matchedRules > maxMatchedRules) {
          maxMatchedRules = matchedRules;
          selectedCombination = combination;
        }
      });
    }

    return selectedCombination;
  };

  handleCombinationChoose = index => {
    const { boatSystems, currentSystem, invalidList } = this.state;
    const { markStepAsRedacted, updateBoatDetails } = this.props;

    markStepAsRedacted();
    const selectedCombination = currentSystem.combinations[index];

    delete invalidList[currentSystem.index];

    this.setState(
      {
        selectedCombination,
        invalidList,
        invalidComponents: {},
        selectedManufacturersFilters: {},
      },
      () => {
        this.validateNotSelectedSystem(currentSystem.index);
        updateBoatDetails({ boatSystems });
      }
    );
  };

  handleTypeChose = ruleId => type => {
    if (this.loadedTypes[type.typeId] === undefined) {
      this.loadedTypes[type.typeId] = false;

      this.loadComponentTypeData(type.typeId);
    }

    let newSelectedTypes = this.state.selectedTypes;
    newSelectedTypes[this.state.currentSystem.index][ruleId] = type.typeId;
    this.setState({ selectedTypes: newSelectedTypes });
  };

  handleSelectManufacturerFilter = combinationSingleTypeHolderId => manufacturer => {
    let { selectedManufacturersFilters } = this.state;
    selectedManufacturersFilters[combinationSingleTypeHolderId] = manufacturer;
    this.setState({ selectedManufacturersFilters });
  };

  selectSingleType = (ruleId, type) => {
    if (this.loadedTypes[type.typeId] === undefined) {
      this.loadedTypes[type.typeId] = false;

      this.loadComponentTypeData(type.typeId);
    }

    if (!type) return 'No Components\' types found';

    if (!this.state.selectedTypes[this.state.currentSystem.index][ruleId]) {
      let newSelectedTypes = this.state.selectedTypes;
      newSelectedTypes[this.state.currentSystem.index][ruleId] = type.typeId;
      this.setState({ selectedTypes: newSelectedTypes });
    }
    return type.value;
  };

  loadComponentTypeData = typeId => {
    http.get(systemAPI.getComponentsByType(typeId, true)).then(({ data }) => {
      let newAllComponents = this.state.allComponents;
      newAllComponents[typeId] = data;
      this.loadedTypes[typeId] = true;

      let newAllManufacturers = this.state.allManufacturers;
      newAllManufacturers[typeId] = Object.keys(data.reduce(this.manufacturersOfSingleTypeReducer, {})).sort();

      this.setState({ allComponents: newAllComponents, allManufacturers: newAllManufacturers });
    });
  };

  manufacturersOfSingleTypeReducer = (accumulator, component) => {
    accumulator[component.manufacturerName] = true;
    return accumulator;
  };

  handleSystemDelete = index => event => {
    const { boatSystems } = this.state;

    event.stopPropagation();

    if (this.isSystemEmpty(index)) {
      if (boatSystems[index].id) {
        http.delete(systemAPI.deleteSystem(boatSystems[index].id)).then(() => {
          this.deleteSystem(index);
        });
      } else {
        this.deleteSystem(index);
      }
    } else {
      this.modalBody = (
        <div>Are you sure you want to remove this Component System? All previously entered data will be lost.</div>
      );
      this.modalConfirmAction = () => {
        if (boatSystems[index].id) {
          http.delete(systemAPI.deleteSystem(boatSystems[index].id)).then(() => {
            this.deleteSystem(index);
            NotificationManager.success('note', 'The Component System was removed successfully.');
          });
        } else {
          this.deleteSystem(index);
          NotificationManager.success('note', 'The Component System was removed successfully.');
        }
      };
      this.setState({ isModalOpen: true });
    }
  };

  deleteSystem = index => {
    const { markStepAsRedacted, updateBoatDetails } = this.props;
    const { boatSystems, currentSystem, dualSteering } = this.state;

    markStepAsRedacted();

    const dualSteeringFlagIsFalse =
      dualSteering &&
      currentSystem.id === 5 &&
      boatSystems.filter(system => system.componentSystemId === 5).length === 1;

    if (dualSteeringFlagIsFalse) this.handleDualSteeringCheck();

    const deletedElements = boatSystems.splice(index, 1);
    updateBoatDetails({ boatSystems });
    this.updateValidationAfterDelete(index, deletedElements);

    const currentSystemIndex = currentSystem.index;
    const newState = { boatSystems, isModalOpen: false };

    if (dualSteeringFlagIsFalse) {
      newState.dualSteering = false;
    }

    if (index <= currentSystemIndex) newState.currentSystem = {};

    this.setState(newState, () => {
      if (this.state.boatSystems.length && index <= currentSystemIndex) {
        this.setSystemsNames(deletedElements[0]);
        if (currentSystemIndex === 0) this.handleSystemChoose(0, true);
        else this.handleSystemChoose(currentSystemIndex - 1, true);
      }
    });
  };

  setSystemsNames = ({ componentSystemId: systemTypeToRename }) => {
    const { boatSystems } = this.state;

    boatSystems.forEach((system, index) => {
      if (!systemTypeToRename || systemTypeToRename === system.componentSystemId) {
        const fullName = this.allSystemsList.find(sys => sys.id === system.componentSystemId).name;
        let systemName = fullName.split('(')[0].trim();
        let sameTypeSystems = 0;
        let systemOrder = 1;
        boatSystems.forEach((otherSystem, otherIndex) => {
          if (otherSystem.componentSystemId === system.componentSystemId) {
            sameTypeSystems++;
            if (otherIndex < index) systemOrder++;
          }
        });
        if (sameTypeSystems !== 1) systemName = systemName + ` (${systemOrder})`;
        boatSystems[index].name = systemName;
      }
    });

    this.setState({ boatSystems });
  };

  updateValidationAfterDelete = (index, deletedElements) => {
    const { invalidList, validList, invalidComponents } = this.state;

    delete validList[index];
    delete invalidList[index];

    Object.keys(validList)
      .sort()
      .forEach(key => {
        if (key > index) {
          validList[key - 1] = validList[key];
          delete validList[key];
        }
      });

    Object.keys(invalidList)
      .sort()
      .forEach(key => {
        if (key > index) {
          invalidList[key - 1] = invalidList[key];
          delete invalidList[key];
        }
      });

    if (deletedElements[0].ruleValueRequests)
      deletedElements[0].ruleValueRequests.forEach(rule => {
        Object.keys(rule.componentIdWithQuantityMap).forEach(componentId => {
          delete invalidComponents[componentId];
        });
      });

    this.setState({ invalidComponents, validList, invalidList });
  };

  isSystemEmpty = index => {
    const { boatSystems } = this.state;
    const activeSystem = boatSystems[index];

    for (let i in activeSystem.optionValueRequests) if (activeSystem.optionValueRequests[i].value !== '') return false;
    for (let i in activeSystem.ruleValueRequests) if (activeSystem.ruleValueRequests[i].value !== '') return false;

    return true;
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  selectComponent = (ruleId, component) => {
    const { markStepAsRedacted } = this.props;
    const { boatSystems, currentSystem, invalidList, savedComponents } = this.state;

    if (!component) return;

    markStepAsRedacted();

    let newSavedComponents = savedComponents;
    component.componentType = {};
    component.componentType.id = component.componentTypeId;
    component.componentType.componentTypeName = this.allTypesList.find(
      type => +type.id === +component.componentTypeId
    ).componentTypeName;
    component.applicationStatus = 'APPROVED';
    newSavedComponents.push(component);

    const activeSystem = boatSystems[currentSystem.index];
    let existingRule = activeSystem.ruleValueRequests.find(rule => rule.ruleId === ruleId);

    if (!existingRule) {
      activeSystem.ruleValueRequests.push({
        ruleId,
        componentIdWithQuantityMap: {},
      });
      existingRule = activeSystem.ruleValueRequests[activeSystem.ruleValueRequests.length - 1];
    }

    existingRule.componentIdWithQuantityMap[component.id] = 1;

    this.setState({ boatSystems, savedComponents: newSavedComponents }, () => {
      if (invalidList[currentSystem.index]) this.validateNotSelectedSystem(currentSystem.index);
    });
  };

  handleAdditionalInput = optionId => value => {
    const { boatSystems, currentSystem } = this.state;

    const element = boatSystems[currentSystem.index].optionValueRequests.find(option => +option.optionId === +optionId);

    if (element) element.value = value;
    else boatSystems[currentSystem.index].optionValueRequests.push({ optionId, value });

    this.setState({ boatSystems });
  };

  removeComponent = (ruleId, componentId) => () => {
    const { markStepAsRedacted } = this.props;
    const { boatSystems, currentSystem, invalidList, invalidComponents } = this.state;
    const activeSystem = boatSystems[currentSystem.index];

    markStepAsRedacted();
    const ruleValueRequest = activeSystem.ruleValueRequests.find(rule => rule.ruleId === ruleId);
    delete ruleValueRequest.componentIdWithQuantityMap[componentId];
    if (!Object.keys(ruleValueRequest.componentIdWithQuantityMap).length) {
      const index = activeSystem.ruleValueRequests.findIndex(rule => rule.ruleId === ruleId);
      activeSystem.ruleValueRequests.splice(index, 1);
    }

    delete invalidComponents[componentId];

    this.setState({ boatSystems, invalidComponents }, () => {
      if (invalidList[currentSystem.index]) this.validateNotSelectedSystem(currentSystem.index);
    });
  };

  updateQuantity = (ruleId, componentId, inc) => () => {
    const { boatSystems, currentSystem } = this.state;
    const activeSystem = boatSystems[currentSystem.index];

    if (inc)
      ++activeSystem.ruleValueRequests.find(rule => rule.ruleId === ruleId).componentIdWithQuantityMap[componentId];
    else --activeSystem.ruleValueRequests.find(rule => rule.ruleId === ruleId).componentIdWithQuantityMap[componentId];

    this.setState({ boatSystems });
  };

  validateNotSelectedSystem = key => {
    const { savedComponents } = this.state;
    const savedSystemData = this.state.boatSystems[key];
    let dataRequests = [];
    if (!this.systemStructures[savedSystemData.componentSystemId]) {
      dataRequests.push(http.get(systemAPI.getBoatSystemStructure(savedSystemData.componentSystemId)));
    }

    let savedComponentsWithoutDataIds = [];

    if (savedSystemData.ruleValueRequests)
      savedSystemData.ruleValueRequests.forEach(savedRule => {
        for (const savedComponentId in savedRule.componentIdWithQuantityMap) {
          if (!savedComponents.find(component => +component.id === +savedComponentId)) {
            savedComponentsWithoutDataIds.push(savedComponentId);
          }
        }
      });
    if (savedComponentsWithoutDataIds.length) {
      dataRequests.push(http.get(systemAPI.getComponent(savedComponentsWithoutDataIds)));
    }

    return Promise.all(dataRequests).then(result => {
      let systemStructureTemplate = result.find(response => {
        return response.data && response.data.combinations;
      });
      if (systemStructureTemplate) {
        systemStructureTemplate = systemStructureTemplate.data;
        this.systemStructures[savedSystemData.componentSystemId] = systemStructureTemplate;
      } else {
        systemStructureTemplate = this.systemStructures[savedSystemData.componentSystemId];
      }
      let newSavedComponents = result.find(response => {
        return response.data && response.data[0] && response.data[0].componentType;
      });
      newSavedComponents = newSavedComponents ? newSavedComponents.data : [];
      const selectedCombinationStructureTemplate = this.getChosenCombination(
        systemStructureTemplate.combinations,
        savedSystemData
      );

      let systemInvalid = false;
      let newInvalidComponents = {};
      let newInvalidSystems = {};
      let newValidSystems = {};
      let chosenTypeIdsForEachCombinationRule = [];

      selectedCombinationStructureTemplate.requiredRules.forEach(ruleTemplate => {
        const savedRuleData = savedSystemData.ruleValueRequests
          ? savedSystemData.ruleValueRequests.find(savedRule => {
            return savedRule.ruleId === ruleTemplate.id;
          })
          : null;
        if (!savedRuleData || !Object.keys(savedRuleData.componentIdWithQuantityMap).length) {
          if (!ruleTemplate.optional) {
            systemInvalid = true;
            if (!newInvalidSystems[key]) newInvalidSystems[key] = {};
            newInvalidSystems[key][ruleTemplate.id] = true;
          }
        } else {
          for (const savedComponentId in savedRuleData.componentIdWithQuantityMap) {
            const componentData = [...newSavedComponents, ...this.state.savedComponents].find(
              component => +component.id === +savedComponentId
            );
            if (
              !chosenTypeIdsForEachCombinationRule[ruleTemplate.id] &&
              ruleTemplate.componentTypeIds.indexOf(componentData.componentType.id) !== -1
            ) {
              chosenTypeIdsForEachCombinationRule[ruleTemplate.id] = componentData.componentType.id;
            }
            if (
              !componentData.manufacturerIsActive ||
              componentData.applicationStatus !== 'APPROVED' ||
              ruleTemplate.componentTypeIds.indexOf(componentData.componentType.id) === -1
            ) {
              systemInvalid = true;
              newInvalidComponents[savedComponentId] = true;
              if (!newInvalidSystems[key]) newInvalidSystems[key] = {};
              newInvalidSystems[key][ruleTemplate.id] = true;
            }
          }
        }
      });

      if (!systemInvalid) newValidSystems[key] = true;

      let newSelectedTypes = this.state.selectedTypes;
      newSelectedTypes[key] = chosenTypeIdsForEachCombinationRule;

      this.setState(
        prevState => {
          let newInvalidList = { ...prevState.invalidList, ...newInvalidSystems };
          let newValidList = { ...prevState.validList, ...newValidSystems };
          if (systemInvalid) delete newValidList[key];
          else delete newInvalidList[key];
          return {
            invalidList: newInvalidList,
            validList: newValidList,
            invalidComponents: { ...prevState.invalidComponents, ...newInvalidComponents },
            selectedTypes: newSelectedTypes,
            savedComponents: [...newSavedComponents, ...prevState.savedComponents],
          };
        },
        () => {
          this.AmountOfNotValidatedSystems--;
        }
      );
    });
  };

  validateSystemBeforeSave = key => {
    const {
      boatSystems,
      invalidList,
      validList,
      invalidComponents,
      selectedCombination: selectedCombinationStructureTemplate,
    } = this.state;

    const savedSystemData = boatSystems[key];
    return new Promise((resolve, reject) => {
      let systemInvalid = false;
      let newInvalidSystems = invalidList;
      let newValidSystems = validList;

      selectedCombinationStructureTemplate.requiredRules.forEach(ruleTemplate => {
        const savedRuleData = savedSystemData.ruleValueRequests
          ? savedSystemData.ruleValueRequests.find(savedRule => {
            return savedRule.ruleId === ruleTemplate.id;
          })
          : null;

        if (!savedRuleData || !Object.keys(savedRuleData.componentIdWithQuantityMap).length) {
          if (!ruleTemplate.optional) {
            systemInvalid = true;
            if (!newInvalidSystems[key]) newInvalidSystems[key] = {};
            newInvalidSystems[key][ruleTemplate.id] = true;
          }
        } else {
          for (const savedComponentId in savedRuleData.componentIdWithQuantityMap) {
            if (invalidComponents[savedComponentId]) {
              systemInvalid = true;
              if (!newInvalidSystems[key]) newInvalidSystems[key] = {};
              newInvalidSystems[key][ruleTemplate.id] = true;
            }
          }
        }
      });
      if (!systemInvalid) newValidSystems[key] = true;

      this.setState({ invalidList: newInvalidSystems, validList: newValidSystems }, () => {
        if (systemInvalid) reject();
        else resolve();
      });
    });
  };

  saveSystem = key => {
    const { boatSystems, selectedCombination } = this.state;
    const { id } = this.props.boat;
    const activeSystem = boatSystems[key];

    return new Promise((resolve, reject) => {
      this.validateSystemBeforeSave(key)
        .then(() => {
          let systemDataPull = {
            boatId: id,
            description: '',
            ...activeSystem,
            ruleValueRequests: [],
          };

          let deleteList = [];

          activeSystem.ruleValueRequests.forEach((filledType, typeIndex) => {
            if (
              selectedCombination.requiredRules.find(rule => {
                return filledType.ruleId === rule.id;
              })
            ) {
              systemDataPull.ruleValueRequests.push(filledType);
            } else {
              deleteList.push(typeIndex);
            }
          });

          let spliceShift = 0;
          deleteList.forEach(index => {
            activeSystem.ruleValueRequests.splice(index - spliceShift, 1);
            spliceShift++;
          });

          if (activeSystem.id) systemDataPull.id = activeSystem.id;

          delete systemDataPull.name;

          http.post(systemAPI.saveSystem, systemDataPull).then(({ data }) => {
            activeSystem.id = data.id;
            this.setState({ boatSystems }, () => {
              resolve();
            });
          });
        })
        .catch(() => {
          reject();
        });
    });
  };

  sendErrorMessage = () => {
    const { invalidList, invalidComponents } = this.state;

    if (Object.keys(invalidComponents).length) {
      NotificationManager.error(2, 'Cannot save application.', 'Please check the Component Systems');
    } else if (Object.keys(invalidList).length) {
      NotificationManager.error(
        'note',
        'Invalid system configuration',
        'Add components to all systems or delete empty ones'
      );
    }
  };

  handleMoveToNextStep = () => {
    const { currentSystem, boatSystems } = this.state;
    const { goToStep, updateBoatDetails } = this.props;

    if (currentSystem.index !== undefined) {
      this.saveSystem(currentSystem.index)
        .then(() => {
          if (this.isValidData()) {
            updateBoatDetails({ boatSystems });
            if (this.AmountOfNotValidatedSystems <= 0) {
              goToStep('next', true);
            } else {
              NotificationManager.error(
                'note',
                'Calculation in progress',
                'Please wait, while system recalculate values'
              );
            }
          } else {
            this.sendErrorMessage();
          }
        })
        .catch(this.sendErrorMessage);
    } else {
      if (this.isValidData()) {
        if (this.AmountOfNotValidatedSystems <= 0) {
          goToStep('next', true);
        } else {
          NotificationManager.error('note', 'Calculation in progress', 'Please wait, while system recalculate values');
        }
      } else {
        this.sendErrorMessage();
      }
    }
  };

  handleMoveToArbitraryStep = stepId => {
    const { currentSystem, boatSystems } = this.state;
    const { goToStep, stepIsChanged, updateBoatDetails } = this.props;

    const step = typeof stepId === 'string' ? stepId : 'prev';

    if (!stepIsChanged) {
      if (this.AmountOfNotValidatedSystems <= 0) {
        return goToStep(step, true);
      } else {
        return NotificationManager.error(
          'note',
          'Calculation in progress',
          'Please wait, while system recalculate values'
        );
      }
    }

    if (currentSystem.index !== undefined) {
      this.saveSystem(currentSystem)
        .then(() => {
          if (this.isValidData()) {
            updateBoatDetails({ boatSystems });
            if (this.AmountOfNotValidatedSystems <= 0) {
              goToStep(step, true);
            } else {
              NotificationManager.error(
                'note',
                'Calculation in progress',
                'Please wait, while system recalculate values'
              );
            }
          } else {
            goToStep(step, false);
          }
        })
        .catch(() => {
          goToStep(step, false);
        });
    } else {
      if (this.isValidData()) goToStep(step, true);
      else goToStep(step, false);
    }
  };

  handleDualSteeringCheck = () => {
    const { markStepAsRedacted, updateBoatDetails } = this.props;
    const { id } = this.props.boat;
    let { dualSteering } = this.state;
    dualSteering = !dualSteering;

    http.patch(boatAPI.saveSteeringSystem(id, dualSteering)).then(() => {
      markStepAsRedacted();
      updateBoatDetails({ dualSteering });
      this.setState({ dualSteering });
    });
  };

  isValidData = () => {
    const { invalidList, invalidComponents } = this.state;
    return !Object.keys(invalidList).length && !Object.keys(invalidComponents).length;
  };

  getCombinationCompositionReminder = () => {
    const { currentSystem } = this.state;

    return (
      <div className='boat-systems-scene__configuration-composition-wrapper'>
        {INFO[currentSystem.id].map((str, index) => (
          <div key={index} className='boat-systems-scene__configuration-composition-text'>{str}</div>
        ))}
      </div>
    );
  };

  render() {
    const {
      boatSystems,
      currentSystem,
      allComponents,
      selectedCombination,
      isModalOpen,
      invalidList,
      validList,
      dualSteering,
      invalidComponents,
      savedComponents,
      selectedManufacturersFilters,
      allManufacturers,
    } = this.state;
    const { getNavBar, stepIsChanged, getHeader, updateBoatDetails } = this.props;

    return (
      <React.Fragment>
        {getHeader(() => {
          return new Promise((resolve, reject) => {
            if (this.isValidData()) {
              this.saveSystem(currentSystem.index).then(() => {
                updateBoatDetails({ boatSystems });
                resolve();
              });
            } else {
              this.sendErrorMessage();
              reject();
            }
          });
        })}
        {getNavBar(this.handleMoveToNextStep, this.handleMoveToArbitraryStep)}
        <Systems
          boatSystems={boatSystems}
          currentSystem={currentSystem}
          invalidList={invalidList}
          validList={validList}
          allSystemsList={this.allSystemsList}
          handleSystemChoose={this.handleSystemChoose}
          handleSystemAdd={this.handleSystemAdd}
          handleSystemDelete={this.handleSystemDelete}
        />
        {dualSteering !== undefined && (
          <SteeringSystemSection
            dualSteering={dualSteering}
            currentSystem={currentSystem}
            handleDualSteeringCheck={this.handleDualSteeringCheck}
          />
        )}
        <AdditionalSection
          boatSystems={boatSystems}
          currentSystem={currentSystem}
          additionalSectionName={this.additionalSectionName}
          handleAdditionalInput={this.handleAdditionalInput}
        />
        <CombinationPicker
          boatSystems={boatSystems}
          currentSystem={currentSystem}
          allComponents={allComponents}
          selectedCombination={selectedCombination}
          handleCombinationChoose={this.handleCombinationChoose}
          getCombinationCompositionReminder={this.getCombinationCompositionReminder}
        />
        <CombinationSection
          boatSystems={boatSystems}
          currentSystem={currentSystem}
          allComponents={allComponents}
          allTypes={this.allTypesList}
          loadedTypes={this.loadedTypes}
          savedComponents={savedComponents}
          selectedCombination={selectedCombination}
          invalidList={invalidList}
          invalidComponents={invalidComponents}
          selectComponent={this.selectComponent}
          removeComponent={this.removeComponent}
          updateQuantity={this.updateQuantity}
          handleTypeChose={this.handleTypeChose}
          selectSingleType={this.selectSingleType}
          selectedTypes={this.state.selectedTypes[currentSystem.index]}
          getCombinationCompositionReminder={this.getCombinationCompositionReminder}
          manufacturersList={allManufacturers}
          selectedManufacturersFilters={selectedManufacturersFilters}
          handleSelectManufacturerFilter={this.handleSelectManufacturerFilter}
        />
        <ApplicationActions
          backButtonLabel='Prev. Step'
          saveButtonLabel='Next Step'
          saveButtonAction={
            stepIsChanged
              ? this.handleMoveToNextStep
              : () => {
                this.handleMoveToArbitraryStep('next');
              }
          }
          backButtonAction={this.handleMoveToArbitraryStep}
        />
        <Modal isOpen={isModalOpen}>
          <header className='ect-modal-header'>Confirmation</header>
          <div className='ect-modal-body'>{this.modalBody}</div>
          <footer className='ect-modal-footer'>
            <Button
              label='No'
              type={buttonType.secondary}
              color={buttonColor.gray}
              buttonClassName='_height_40 _width_160'
              onClick={this.closeModal}
            />
            <Button label='Yes' buttonClassName='_height_40 _width_160' onClick={this.modalConfirmAction} />
          </footer>
        </Modal>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/AddComponents/index.jsx